var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVue = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 196.32 170.02",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#42b883",
  d: "M120.83 0 98.16 39.26 75.49 0H0l98.16 170.02L196.32 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#35495e",
  d: "M120.83 0 98.16 39.26 75.49 0H39.26l58.9 102.01L157.06 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVue);
export default ForwardRef;